<template>
    <div>
        <div class="ls-address">
            <p class="ls-address__icon ls-margin--top-none">
                <a
                    v-ls-track.click="{
                        target: 'change-address--icon-link',
                    }"
                    aria-label="Change Address Icon"
                    @click.prevent="openModal('changeAddress')"
                >
                    <i class="fa fa-map-marker ls-color--red--color-dodge"></i>
                </a>
            </p>

            <div class="ls-address__address-display ls-margin--top-none">
                <a
                    v-ls-track.click="{
                        target: 'change-address--banner-link',
                    }"
                    class="ls-truncate"
                    aria-label="Change Address"
                    @click.prevent="openModal('changeAddress')"
                >
                    <strong class="ls-truncate" data-font-size="-2">
                        {{ order.address.street }}
                    </strong>
                    <br />
                    <span class="ls-truncate ls-color--gray--mid" data-font-size="-3">
                        {{ order.address.city }},
                        {{ order.address.state }}
                        {{ order.address.zip }}
                    </span>
                </a>
                <div style="display: inline-block; padding-left: 5px;">
                    <button
                        v-ls-track.click="{
                            target: 'change-address--edit-button',
                        }"
                        type="button"
                        class="ls-button ls-button--xs"
                        :class="{
                            'ls-button--white': !order.saved_order,
                            'ls-button--blue': order.saved_order,
                        }"
                        @click.prevent="openModal('changeAddress')"
                    >
                        <i class="fa fa-pencil"></i>
                    </button>
                </div>
            </div>

            <p
                v-if="this.$route.meta.showOrderSummary && mowingTotalPricePerService"
                class="ls-margin--top-none"
            >
                <strong>
                    <span v-if="!cart.loadingStatus.calculatingTotal">{{
                        mowingTotalPricePerService | lsMoney
                    }}</span
                    ><!-- no whitespace
                --><span v-else><i class="fa fa-pulse fa-spinner"></i></span>
                </strong>
            </p>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapGetters, mapActions } from 'vuex';
import * as types from '@/store/types';

export default {
    props: {},
    computed: {
        ...mapState(['order', 'cart']),
        ...mapGetters({
            mowingInCart: types.CART__GET_MOWING_IN_CART,
            cartTotals: types.ORDER__GET_CART_TOTALS,
        }),
        mowingTotalPricePerService() {
            return _.get(this.cartTotals, 'total_amount');
        },
    },
    methods: {
        ...mapActions({
            openModal: types.MODAL__OPEN_MODAL,
        }),
    },
};
</script>

<style lang="scss" scoped>
.ls-address {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.ls-address__icon {
    margin-right: rem(-3);
}

.ls-address__address-display {
    display: flex;
    flex: 1 1 auto;
    width: 0;
    max-width: 100%;
    margin-top: 0;
    margin-right: 5px;
    overflow: visible;
    line-height: 14px;
}

.themed-lawnlove {
    .ls-button {
        &.ls-button--xs {
            &.ls-button--blue {
                border-color: $theme-color-grey;
                color: $theme-color-grey-darker;
                box-shadow: none;
                background-color: $theme-color-white;
                background-image: none;
            }
        }
    }
}
</style>
